import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=7b9721ea&scoped=true&"
import script from "./MessageIcon.vue?vue&type=script&lang=js&"
export * from "./MessageIcon.vue?vue&type=script&lang=js&"
import style0 from "./MessageIcon.vue?vue&type=style&index=0&id=7b9721ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9721ea",
  null
  
)

export default component.exports